import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { AuthService } from '../../../service/auth.service';
import { LanguageService } from '../../../../shared/service/language/language.service';
import { ActionState } from '../../../model/enums/auth-state.enum';
import { Language } from '../../../../shared/model/interfaces/language.interface';
import { AuthMessageResponse } from '../../../model/interfaces/auth-message-response.interface';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-control-resend-code',
  templateUrl: './control-resend-code.component.html',
  styleUrl: './control-resend-code.component.scss',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ControlResendCodeComponent,
      multi: true,
    },
  ],
})
export class ControlResendCodeComponent implements OnInit {
  protected authService = inject(AuthService);
  private languageService = inject(LanguageService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() parentComponent!: any;
  @Input() info = '';

  state: ActionState = ActionState.PENDING;
  messages: AuthMessageResponse[] = [];
  value = '';

  form: FormGroup = new FormGroup({ mfaOption: new FormControl('', Validators.required) });

  language: Language;

  public mfaOptionSelected = '';

  onMfaOptionChange() {
    this.mfaOptionSelected = this.form.controls['mfaOption'].value;
    this.authService.resetMessages(this);
  }

  constructor() {
    const authService = this.authService;
    const languageService = this.languageService;

    this.authService = authService;
    this.language = languageService.getLanguage();
  }

  ngOnInit(): void {
    if (!this.authService.mfaOptions) {
      this.initMfaOptionsAndUpdateForm();
    } else {
      this.updateForm();
    }
  }

  private async initMfaOptionsAndUpdateForm(): Promise<void> {
    try {
      await this.authService.initMfaOptions(this);
      this.updateForm();
    } catch (error) {
      console.error(' Error initializing MFA_PROCESS options:', error);
    }
  }

  private updateForm(): void {
    if (this.authService.mfaOptions) {
      this.form.controls['mfaOption'].setValue(this.authService.mfaOptions.default_option);
    }
  }

  async onSubmit() {
    this.authService.handleFormAction(this);

    const verificationSource =
      this.parentComponent.isForceMfa && this.parentComponent.forceMfaForm.controls['mfaInputValue'].value;

    const payload = {
      username: this.authService.username,
      password: this.authService.password,
      project: this.authService.projectName || null,
      resendVia: this.form.value.mfaOption,
      verificationSource: verificationSource || null,
    };

    try {
      const response = await this.authService.authMfaResendCode(payload);
      this.authService.finalizeAction(this, ActionState.SUCCESS, [response.msg || '']);
    } catch (error: unknown) {
      const errorCode: string | string[] = error instanceof Error ? error.message : '';
      const errorCodes = Array.isArray(errorCode) ? errorCode : [errorCode];
      this.authService.finalizeAction(this, ActionState.FAILURE, errorCodes);
    }
  }
}
